<template>
    <div class="card" v-if="isNotCompleted">
        <div class="card-header">
            <span class="card-title">Update Employer</span>
        </div>
        <div class="card-body p-0">

            <div class="alert alert-info" style="border-radius: 0px;" v-if="!auditableItem.employer">
                Our records didn't find any ATE associated to the ATT of the current Field Inspection, please update the correct Employer information.
            </div>

            <div class="p-3">
                <div>
                    <search-user filter="employers" placeholder="Search by employer name..." v-model="form.employer_id"></search-user>
                    <button class="btn btn-success" @click="save()" v-if="canSave" :disabled="form.isSubmitted">Save</button>
                </div>

                <a @click="saveUsingTechnician()"
                   class="btn p-0 pointer mt-3 text-danger font-weight-bold"
                   v-if="auditableItem.technician.is_employer && !value.employer">
                    Is the same as ATT.
                </a>
            </div>
        </div>
    </div>
</template>
<script>

    export default {

        props: {
            value: {
                type: Object,
                required: true,
            },
            updateUrl: {
                type: String,
                required: true,
            }
        },

        data() {
            return {
                auditableItem: this.value,
                employer: this.value.employer,
                form: new Form({
                    employer_id: this.value.employer ? this.value.employer_id : null,
                }).dontClear()
            }
        },

        methods: {
            save() {
                this.form.patch(this.updateUrl).then(response => {
                    this.refreshPage();
                });
            },

            saveUsingTechnician() {
                this.form.employer_id = this.auditableItem.technician.id;
                this.save();
            }
        },

        computed:{

            canSave(){
                return this.form.employer_id != null && (this.form.employer_id != this.auditableItem.employer.id);
            },

            isNotCompleted(){
                return this.auditableItem.status === null
            },
        }
    }
</script>
